import { CopyTextProvider } from '@bambi/component-library/src/components/CopyButton/useCopyText';
import { useCallback } from 'react';

import { useAppDispatch } from 'src/app/store/hooks';
import { show } from 'src/common/primitives/Toast/toast.slice';

/** Announces copy-to-clipboard results from useCopyText/CopyButton as toasts. */
export function CopyTextToastProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const dispatch = useAppDispatch();

  const onCopySuccess = useCallback(() => {
    dispatch(
      show({
        title: 'Text copied to clipboard',
        type: 'success',
      })
    );
  }, [dispatch]);

  const onCopyError = useCallback(() => {
    dispatch(
      show({
        title: 'Failed to Copy',
        description:
          'Your browser does not support copying to the clipboard, please copy manually.',
        type: 'error',
      })
    );
  }, [dispatch]);

  return (
    <CopyTextProvider onCopySuccess={onCopySuccess} onCopyError={onCopyError}>
      {children}
    </CopyTextProvider>
  );
}
